import { render, staticRenderFns } from "./MagazineCell.component.vue?vue&type=template&id=3707b899&scoped=true&"
import script from "./MagazineCell.component.vue?vue&type=script&lang=ts&"
export * from "./MagazineCell.component.vue?vue&type=script&lang=ts&"
import style0 from "./MagazineCell.component.vue?vue&type=style&index=0&id=3707b899&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3707b899",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VImg,VProgressCircular,VRow})
